import React, { UIEvent, UIEventHandler } from "react";
import { useDispatch } from "react-redux";

import { Grid } from "@mui/material";

import { useLoggedInUser } from "../../../../../api/user-auths/login";
import { dispatchExperienceAnalysis } from "../../../../../store/slices/ai";

import { AskQuestionRow } from "./AskQuestionRow";
import { Messages } from "./Messages";

export const MessagePanel = () => {
  const user = useLoggedInUser();
  const dispatch = useDispatch();

  const onScroll = (e: UIEvent<HTMLDivElement, UIEvent>) => {
    // @ts-expect-error
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const position = Math.ceil(
      (scrollTop / (scrollHeight - clientHeight)) * 100
    );

    dispatch(
      dispatchExperienceAnalysis({
        type: "setAutoScroll",
        value: position >= 90,
      })
    );
  };

  return (
    <Grid container item direction={"column"}>
      <Grid
        id={"msg-panel"}
        // @ts-ignore
        onScroll={(e) => onScroll(e)}
        container
        item
        sx={{
          maxHeight: "50vh",
          overflowY: "scroll",
          paddingRight: "10px",
        }}
      >
        <Messages
          name={
            user.data
              ? `${(user.data.user.firstName || "I").charAt(0)}${(
                  user.data.user.lastName || "G"
                ).charAt(0)}`
              : "IG"
          }
        />
      </Grid>
      <Grid item sx={{ marginLeft: "70px" }}>
        <Grid item>
          <AskQuestionRow />
        </Grid>
      </Grid>
    </Grid>
  );
};
